import React, { createContext, useState, useContext, useEffect } from "react";

const AuthContext = createContext(null);

const AUTH_ENDPOINTS = {
  login: "https://gift-login-336444799661.us-central1.run.app/giftLogin",
  forgotPassword: "https://gift-requestpwdreset-v2-336444799661.us-central1.run.app",
  resetPassword: "https://gift-confirmpwdreset-336444799661.us-central1.run.app",
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // console.log('🔄 AuthProvider inicializando...'); // ✅ DEBUG

    const storedUser = localStorage.getItem("user");
    const storedToken = localStorage.getItem("token"); // ✅ AGREGAR ESTA LÍNEA
    
    // console.log('📦 localStorage user:', storedUser); // ✅ DEBUG
    // console.log('📦 localStorage token:', storedToken); // ✅ DEBUG
    
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      // console.log('✅ Usuario recuperado:', parsedUser); // ✅ DEBUG
      setUser(parsedUser);
    } else {
      // console.log('⚠️ No hay usuario en localStorage'); // ✅ DEBUG
    }
    
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const response = await fetch(AUTH_ENDPOINTS.login, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      // console.log('🔍 Login response:', data); // ✅ DEBUG
      
      if (data.success) {
        // console.log('💾 Guardando en localStorage...'); // ✅ DEBUG
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        
        // console.log('✅ Token guardado:', localStorage.getItem('token')); // ✅ DEBUG
        // console.log('✅ User guardado:', localStorage.getItem('user')); // ✅ DEBUG
        
        setUser(data.user);

        return { success: true, role: data.user.role };
      }

      return { success: false, error: data.error };
    } catch (err) {
      console.error('❌ Error en login:', err); // ✅ DEBUG
      return { success: false, error: "Error de conexión" };
    }
  };

  const register = async (formData) => {
    console.log("Registration data:", formData);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return {
      success: true,
      message: "Te enviaremos un email de confirmación en las próximas 24 horas.",
    };
  };

  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setUser(null);
  };

  const requestPasswordReset = async (email) => {
    try {
      const response = await fetch(AUTH_ENDPOINTS.forgotPassword, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      let data = null;
      try {
        data = await response.json();
      } catch (_) {}

      if (!response.ok) {
        console.warn("requestPasswordReset non-200:", data);
      }

      return {
        success: true,
        message:
          "Si el email está registrado, recibirás instrucciones para recuperar tu contraseña.",
      };
    } catch (err) {
      console.error("requestPasswordReset error:", err);
      return {
        success: true,
        message:
          "Si el email está registrado, recibirás instrucciones para recuperar tu contraseña.",
      };
    }
  };

  const confirmPasswordReset = async ({ email, token, newPassword }) => {
    const response = await fetch(AUTH_ENDPOINTS.resetPassword, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, token, newPassword }),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok || data?.success === false) {
      throw new Error(data?.error || "No se pudo restablecer la contraseña.");
    }

    return data;
  };

  const value = {
    user,
    loading,
    login,
    logout,
    register,
    requestPasswordReset,
    confirmPasswordReset,
    isAuthenticated: !!user,
    isAdmin: user?.role === "admin",
    isCouple: user?.role === "couple",
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};